import CaseFirstViewWhite from 'components/cases/common/CasesFirstViewWhite/'
import OverView from 'components/cases/common/Overview/'
import Interview from 'components/cases/dir/Interview/Interview'
import CaseStudyNew from '../../home/CaseStudy/CaseStudyNew'
import {
  firstViewItemWhite,
  overviewItem,
  overviewTitle,
  issueSolutionItems,
  caseCTAItem,
  caseDownloadCTAItem,
} from './dirItems'
import styles from './dir.module.scss'
import CaseCTA from 'components/cases/common/CaseCTA'
import CaseDownloadCTA from 'components/cases/common/CaseDownloadCTA'
import FooterCTA from 'components/common/FooterCTA'

const Dir = (): JSX.Element => {
  return (
    <>
      <CaseFirstViewWhite firstViewItemWhite={firstViewItemWhite} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <CaseDownloadCTA {...caseDownloadCTAItem} />
      <FooterCTA />
      <div className={styles.line}>
        <CaseStudyNew />
      </div>
    </>
  )
}

export default Dir
